import styled from 'styled-components';
import { CaretDownOutlined } from '@ant-design/icons';
import { is } from 'typescript-styled-is';

export const TreeWrapper = styled.div<{ expanded: boolean }>`
  margin-left: 16px;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.1s;
  ${(props) =>
    (props.expanded &&
      `
  transition: max-height .8s;
  max-height:500px;      
`) ||
    ''}
`;
export const ErrorBox = styled.div`
  opacity: 0;
  align-self: flex-start;
  ${is('hasError')`
    opacity:1;
    color: ${({ theme }) => theme.color.error};
  `}
`;
export const BranchContent = styled.div`
  margin-top: 4px;
  display: flex;
  label: {
    overflow: hidden;
    textoverflow: ellipsis;
  }
`;
export const TreeRoot = styled.div`
  &:not(:first-child): {
    margintop: 8px;
  }
`;
export const CheckBoxWrapper = styled.div<{ displayable?: boolean }>`
  transition: all 0.3s;
  ${(props) => (props.displayable === false && 'opacity:0;') || ''}
  position:absolute;
  left: 0px;
`;

export const ExpandIcon = styled(CaretDownOutlined)<{ expanded?: boolean }>`
  margin-right: 4px;
  cursor: pointer;
  transition: transform 0.2s;
  ${(props) => (props.expanded === false && 'transform: rotate(-90deg);') || ''}
`;

export const SelectedCount = styled.div`
  display: none;
  font-size: 12px;
  line-height: 16px;
  text-align: right;
  color: #6c757d;
`;
